import React, { useState } from 'react';
import { catTree, dateFormatHadith, lineBreak } from '../../../module/ConstantFunctions';
import { RichTextPreviewer } from '../../../core/components/RichTextPreviewer';

function HadithPost({ data, selectedHadith, setSelectedHadith, index, addToDay }) {
  const [confirmLoader, setConfirmLoader] = useState(false);

  return (
    <div className=" items-center justify-between bg-[#eef2f0] px-6 py-6 rounded-s-lg w-full mt-[16px]" key={index}>
      <div className="flex items-center justify-end w-full mb-[10px] relative">
        <div className="flex items-center justify-between  w-full h-[12px]">
          <div
            className={`w-[20px] h-[20px] ${
              dateFormatHadith(data.hadith_date_post) === dateFormatHadith(new Date().toISOString())
                ? 'border-[#1d9236]'
                : 'border-black'
            } rounded-full border-[2px] cursor-pointer flex items-center justify-center  left-0`}
            onClick={() =>
              addToDay(
                data,
                setConfirmLoader,
                dateFormatHadith(data.hadith_date_post) === dateFormatHadith(new Date())
                  ? null
                  : dateFormatHadith(new Date())
              )
            }>
            <div
              className={
                dateFormatHadith(data.hadith_date_post) === dateFormatHadith(new Date().toISOString())
                  ? 'bg-[#1d9236] w-[10px] h-[10px] rounded-full'
                  : ''
              }></div>
          </div>
          <div className="flex items-center justify-end w-[calc(100%-20px)]">
            <span className="text-ellipsis numberHaith font-bold urduText ml-[16px] text-[#0e3a1f] text-[21px] whitespace-nowrap line-clamp-1">
              {`[${data.reference}]`}
              {/* [Sahi BUkhari] */}
            </span>
          </div>
        </div>
      </div>
      <p dir="ltr" className="urduText leading-[36px] font-bold line-clamp-4 text-text-ellipsis">
        ({data.post_number}) {data.preview}
      </p>
      <div className="flex items-center justify-end w-full">
        <p dir="ltr" className="urduText font-normal text-[#0e3a1f] text-[20px]  text-text-ellipsis  line-clamp-1 ">
          {catTree(data)}
          {/* {`صحيح البخاري > صحيح البخاري1 > صحيح البخاري3 > صحيح البخاري5  `} */}
        </p>
      </div>
    </div>
  );
}

export default HadithPost;
